import { PlayersReport } from '@/models/players-report/players-report.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { defineStore } from 'pinia';

interface PlayersReportState {
  isPlayersReportLoading: boolean;
  playersReport: PlayersReport;
}

export const usePlayersReportStore = defineStore('PlayersReportStore', {
  state: (): PlayersReportState => ({
    isPlayersReportLoading: false,
    playersReport: null,
  }),
  actions: {
    setPlayersReportLoading(isLoading: boolean): void {
      this.isPlayersReportLoading = isLoading;
    },
    getPlayersReport(whitelabelSlug: string): Promise<PlayersReport> {
      this.setPlayersReportLoading(true);

      return api.playersReport.getPlayersReportRequest.perform(whitelabelSlug)
        .then((data: PlayersReport): PlayersReport => {
          this.playersReport = data;

          return data;
        })
        .catch((error) => {
          showErrorNotification(error);

          return null;
        })
        .finally(() => {
          this.setPlayersReportLoading(false);
        });
    },
  },
});
